import { Lock, Link2 } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { zl, carLabel } from "@/lib/api";
import { StepHeader, NextButton } from "./StepHeader";
import { Summary } from "./Summary";

export const StepCustomize = ({ ctx }) => {
  const { b, update, config, pkg, go } = ctx;
  const byId = Object.fromEntries(config.addons.map((a) => [a.id, a]));
  const withReqs = (ids) => {
    const out = new Set();
    const stack = [...ids];
    while (stack.length) {
      const i = stack.pop();
      if (byId[i] && !out.has(i)) { out.add(i); stack.push(...(byId[i].requires || [])); }
    }
    return [...out];
  };
  const lockedBy = (id) => b.addons.filter((x) => x !== id && (byId[x]?.requires || []).includes(id)).map((x) => byId[x].name);
  const toggle = (id) => {
    if (!b.addons.includes(id)) return update({ addons: withReqs([...b.addons, id]) });
    if (lockedBy(id).length === 0) update({ addons: b.addons.filter((x) => x !== id) });
  };
  return (
    <section data-testid="step-customize">
      <StepHeader onBack={() => go("package")} title="Dostosuj swój pakiet" />
      <p className="-mt-6 mb-8 text-sm text-primary">
        Pakiet: {pkg.name} <span className="text-white/40 mx-2">|</span> <span className="text-white/80">{carLabel(b.car)}</span>
        <span className="text-white/40 mx-2">|</span> <span className="text-white/80">{zl(pkg.prices[b.car])}</span>
      </p>
      <div className="grid lg:grid-cols-[1fr_380px] gap-8">
        <div className="rise d1">
          {pkg.included?.length > 0 && <>
            <h3 className="font-semibold mb-3">Usługi obowiązkowe</h3>
            <div className="space-y-3 mb-8">
              {pkg.included.map((s) => (
                <div key={s} className="flex items-center gap-3 text-sm text-white/80"><Checkbox checked disabled className="data-[state=checked]:bg-primary data-[state=checked]:text-black opacity-100" />{s}</div>
              ))}
            </div>
          </>}
          <h3 className="font-semibold mb-3">Opcje dodatkowe</h3>
          <div className="space-y-2">
            {config.addons.length === 0 && <p className="text-sm text-muted-foreground">Brak opcji dodatkowych.</p>}
            {config.addons.map((a) => {
              const on = b.addons.includes(a.id);
              const locks = on ? lockedBy(a.id) : [];
              const reqs = (a.requires || []).map((r) => byId[r]?.name).filter(Boolean);
              return (
                <label key={a.id} data-testid={`addon-option-${a.id}`} className={`flex items-center gap-3 px-4 py-3 rounded-lg border transition-colors ${locks.length ? "cursor-not-allowed" : "cursor-pointer"} ${on ? "border-primary/70 bg-primary/5" : "border-white/12 bg-black/40 hover:border-white/30"}`}>
                  <Checkbox checked={on} disabled={locks.length > 0} onCheckedChange={() => toggle(a.id)} className="data-[state=checked]:bg-primary data-[state=checked]:text-black border-white/40 disabled:opacity-100" />
                  <span className="flex-1 text-sm">
                    {a.name}
                    {locks.length > 0 && <span data-testid={`addon-locked-${a.id}`} className="flex items-center gap-1 text-xs text-primary/90 mt-0.5"><Lock size={11} /> Wymagane przez: {locks.join(", ")}</span>}
                    {!on && reqs.length > 0 && <span className="flex items-center gap-1 text-xs text-white/50 mt-0.5"><Link2 size={11} /> Doda automatycznie: {reqs.join(", ")}</span>}
                  </span>
                  <span className="text-sm text-white/80">+{zl(a.price)}</span>
                </label>
              );
            })}
          </div>
        </div>
        <div className="rise d2">
          <Summary ctx={ctx} />
          <NextButton className="w-full mt-4" onClick={() => go("term")} />
        </div>
      </div>
    </section>
  );
};
